import axios from "../services/api/api";

export const FETCH_STUDENT_INFORMATION_BEGIN =
  "FETCH_STUDENT_INFORMATION_BEGIN";
export const FETCH_STUDENT_INFORMATION_FULFILLED =
  "FETCH_STUDENT_INFORMATION_FULFILLED";
export const FETCH_STUDENT_INFORMATION_REJECTED =
  "FETCH_STUDENT_INFORMATION_REJECTED";

export const FETCH_STUDENT_COURSES = "FETCH_STUDENT_COURSES";
export const FETCH_STUDENT_COURSES_FULFILLED =
  "FETCH_STUDENT_COURSES_FULFILLED";
export const FETCH_STUDENT_COURSES_REJECTED = "FETCH_STUDENT_COURSES_REJECTED";

export function fetchStudentCoursesAction() {
  return function (dispatch) {
    if (localStorage.getItem("email")) {
      dispatch({
        type: FETCH_STUDENT_COURSES,
        payload: { fetching: true },
      });

      axios
        .get("/student/MyCourses")
        .then((response) => {
          dispatch({
            type: FETCH_STUDENT_COURSES_FULFILLED,
            payload: response.data.result,
          });
        })
        .catch((err) => {
          dispatch({
            type: FETCH_STUDENT_COURSES_REJECTED,
            payload: err,
          });
        });
    }
  };
}

export function fetchStudentResultAction() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get("/student/MyCourses")
        .then((response) => {
          dispatch({
            type: FETCH_STUDENT_COURSES_FULFILLED,
            payload: response.data.result,
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({ type: FETCH_STUDENT_COURSES_REJECTED, payload: err });
          reject(err);
        });
    });
  };
}

export const FETCH_STUDENTS_FOR_SCHOOL_BEGIN =
  "FETCH_STUDENTS_FOR_SCHOOL_BEGIN";
export const FETCH_STUDENTS_FOR_SCHOOL_FULFILLED =
  "FETCH_STUDENTS_FOR_SCHOOL_FULFILLED";
export const FETCH_STUDENTS_FOR_SCHOOL_REJECTED =
  "FETCH_STUDENTS_FOR_SCHOOL_REJECTED";
export function fetchStudentsForSchool(schoolId) {
  return (dispatch) => {
    dispatch({
      type: FETCH_STUDENTS_FOR_SCHOOL_BEGIN,
      payload: { loading: true },
    });
    return new Promise((resolve, reject) => {
      axios
        .get("/SchoolsForAdmin")
        .then((response) => {
          dispatch({
            type: FETCH_STUDENTS_FOR_SCHOOL_FULFILLED,
            payload: response.data.result,
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({ type: FETCH_STUDENTS_FOR_SCHOOL_REJECTED, payload: err });
          reject(err);
        });
    });
  };
}
